<style lang="less">@import "../css/login.less";</style>
<template>
    
</template>

<script>
import { singleSignOn } from '@/api/login'
import config from '@/config';
export default {
    name: 'login',
    data() {
        return {
            title: config.title,
            imgServer: config.imgServer,
            login: {
                a: '',
                b: '',
            },
            msg: '',
        }
    },
    mounted() {
        this.login.a = this.$route.query.sys_id
        this.login.b = this.$route.query.token
        this.doLogin()
    },
    methods: {
        doLogin(){
            if (this.$isNull(this.login.a) || this.$isNull(this.login.b)) {
                this.$msg("参数错误")
                return
            }
            let token = this.login.b.replaceAll(" ", "abcdefghijkllj")
            singleSignOn(this.login.a, token).then(res=>{
                localStorage.removeItem("navIds")
                localStorage.removeItem("navTags")
                localStorage.removeItem("actMenu")
                if(res.code == 1){
                    sessionStorage.setItem("U_TOKEN", res.msg)
                    let redirectPath = sessionStorage.getItem("redirectPath")
                    if(this.$isNotNull(redirectPath)){
                        sessionStorage.removeItem("redirectPath")
                        this.$router.push({path: redirectPath})
                    }else{
                        this.$router.push({path: '/home'})
                    }
                }else if(res.code ==2 || res.code ==3 || res.code == 4){
                    this.$router.push({path: '/map'})
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
}
</script>